import FleetManagement from './FleetManagement';

// eslint-disable-next-line import/prefer-default-export
export { FleetManagement };
